import React, { useState } from "react";
import PageStyle from "../../../Components/Layout/PageLayout";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import {
  useDeleteSurveyMutation,
  useGetFinanceSurveyQuery,
} from "../../../../api/financeApi";
import Table from "../../../Components/Table/Table";
import { TableActions } from "../../../Components/Misc/Actions";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { filterSurveyStatus } from "./index.js";
import toast from "react-hot-toast";
import DeleteItemModal from "../../../Components/Modals/DeleteItemModal.js";
import Pagination from "../../../Components/Pagination/Pagination";
const FeedbackSurvey = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [purpose, setPurpose] = useState(1);

  const [selectedId, setSelectedId] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const navigate = useNavigate();
  const actionButton = (
    <CTAButtons
      onClick={() => navigate("/dashboard/finance/feedback-survey/create")}
    >
      New Survey
    </CTAButtons>
  );
  const { data, isLoading } = useGetFinanceSurveyQuery({
    CategoryType: purpose,
    Status: filter,
    PageSize: pageSize,
    PageNumber: currentPage,
    StartDate: startDate,
    EndDate: endDate,
  });
  const handleEdit = (id) => {
    if (id) {
      navigate(`${id}/edit`);
    }
  };
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  const handleOpenDeleteModal = (id) => {
    if (id) {
      setSelectedId(id);
      setOpenDelete(true);
    }
  };
  const [onDelete, { isLoading: deleteLoading }] = useDeleteSurveyMutation();
  const handleDelete = async () => {
    try {
      const response = await onDelete({id: selectedId}).unwrap();
      if (response?.successful) {
        setOpenDelete(false);
        toast.success(response?.statusMessage);
      }
    } catch (e) {
      toast.error(e?.data?.statusMessage);
    }
  };
  const handleCloseDelete = () => setOpenDelete(false);
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.result?.length > 0 ? (
    data?.result?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.createdBy}</td>
          <td>{item?.categoryTypeName}</td>
          <td>{item?.questionCount}</td>
          <td>{FormatDateTime(item?.createdDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view`}>
              {[
                {
                  name: item?.approvalStatus !== 0 ? "Edit" : null,
                  action:
                    item?.approvalStatus !== 0
                      ? () => handleEdit(item.id)
                      : null,
                },
                {
                  name: "View",
                  action: () => handleView(item.id),
                },
                {
                  name: "Delete",
                  action: () => handleOpenDeleteModal(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Survey Found
      </td>
    </tr>
  );
   const purposes = [
    { name: "Business Development", filter: 1 },
    { name: "Relationship Management", filter: 2 },
  ];
  return (
    <RouteLayout navHidden={true}>
      <PageStyle hasBack={false} demoTitle={"Feedback Survey"} hasTopPageDemo>
        <div className="flex justify-between items-center">
          <form className={DashboardStyle.dashboard_filter}>
            <ProDropFilter
              filter={purpose}
              setFilter={setPurpose}
              name={"Category"}
              filterBy={purposes}
            />
            <SearchFilter
              value={searchText}
              text={(searchText) => setSearchText(searchText)}
            />
            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              normalDate
            />
            <ProDropFilter
              filter={filter}
              setFilter={setFilter}
              name={"Status"}
              filterBy={filterSurveyStatus}
            />
          </form>
          <div>{actionButton}</div>
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                <th>S/N</th>
                <th style={{ cursor: "pointer" }}>Created By</th>
                <th style={{ cursor: "pointer" }}>Category</th>
                <th style={{ cursor: "pointer" }}>Question Count</th>
                <th style={{ cursor: "pointer" }}>Date Created</th>
                <th style={{ cursor: "pointer" }}>Approval Status</th>
                <th style={{ cursor: "pointer" }}>Actions</th>
              </tr>
            </thead>
            <tbody>{tableContent}</tbody>
          </Table>
        </div>
        <Pagination
          last_page={data?.totalPages}
          present_page={data?.currentPage}
          totalRows={data?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setCurrentPage(page)}
        />
      </PageStyle>
      <DeleteItemModal
        isOpen={openDelete}
        handleClose={handleCloseDelete}
        handleDelete={handleDelete}
        headText={"Delete Survey"}
        infoText={"Are you sure you want to Delete this Survey?"}
        isLoading={deleteLoading}
      />
    </RouteLayout>
  );
};

export default FeedbackSurvey;
